import React from 'react'
import { Link, graphql } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Tool } from '../../firms/firm/mapper'

type OfferToolsProps = {
  tools: Tool[] | null
}

const OfferTools: React.FC<OfferToolsProps> = ({ tools }) => (
  <div>
    {tools && tools.length > 0 && (
      <div className="p-4">
        <h2 className="text-md mb-3 text-left">Logiciels</h2>
        <ul>
          {tools.map((tool) =>
            tool ? (
              <Link
                to={`/outils/${tool.slug}`}
                target="_blank"
                key={tool?.name}
              >
                <li className="text-sm my-1 flex flex-row items-center gap-1">
                  <div className="w-8 h-8 flex items-center object-contain rounded-2xl">
                    {tool.logo &&
                      typeof tool.logo !== 'string' &&
                      'images' in tool.logo && (
                        <GatsbyImage
                          image={tool.logo}
                          alt={tool?.name ?? 'Outil'}
                        />
                      )}
                    {tool.logo && typeof tool.logo === 'string' && (
                      <img src={tool.logo} alt={tool?.name ?? 'Outil'} />
                    )}
                    {!tool.logo && tool.logoUrl && (
                      <img src={tool.logoUrl} alt={tool?.name ?? 'Outil'} />
                    )}
                    {!tool.logo && !tool.logoUrl && (
                      <img
                        src="../../../Logo_V_Lamacompta.jpg"
                        alt="Logo par défaut de l'outil"
                      />
                    )}
                  </div>
                  <div className="h-8 flex items-center">{tool?.name}</div>
                </li>
              </Link>
            ) : null,
          )}
        </ul>
      </div>
    )}
  </div>
)

export default OfferTools

export const query = graphql`
  fragment OfferTools on STRAPI_ACCOUNTING_OFFER {
    accountingTools {
      name
      id
      logo {
        localFile {
          childImageSharp {
            gatsbyImageData
          }
          extension
          url
        }
      }
      permalink
    }
  }
`
